import axios from '../utils/axios';

export default function fetchRecruiterIncompleteCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/incomplete-recruiter-count', { params })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}